import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconMagicWand2 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.906 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M20.908,6.000 C20.908,4.500 19.414,3.000 17.920,3.000 C19.414,3.000 20.908,1.500 20.908,0.000 C20.908,1.500 22.403,3.000 23.897,3.000 C22.403,3.000 20.908,4.500 20.908,6.000 ZM19.620,8.707 L4.676,23.707 C4.482,23.903 4.227,24.000 3.972,24.000 C3.717,24.000 3.462,23.903 3.268,23.707 L0.279,20.707 C-0.110,20.317 -0.110,19.683 0.279,19.293 L15.223,4.293 C15.612,3.902 16.242,3.902 16.632,4.293 L19.620,7.293 C20.010,7.683 20.010,8.316 19.620,8.707 ZM2.392,20.000 L3.972,21.586 L14.020,11.500 L12.440,9.914 L2.392,20.000 ZM15.927,6.415 L13.849,8.500 L15.429,10.086 L17.507,8.000 L15.927,6.415 ZM10.946,6.000 C10.946,4.500 9.451,3.000 7.957,3.000 C9.451,3.000 10.946,1.500 10.946,0.000 C10.946,1.500 12.440,3.000 13.935,3.000 C12.440,3.000 10.946,4.500 10.946,6.000 ZM20.410,11.000 C20.410,12.750 22.154,14.500 23.897,14.500 C22.154,14.500 20.410,16.250 20.410,18.000 C20.410,16.250 18.667,14.500 16.923,14.500 C18.667,14.500 20.410,12.750 20.410,11.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconMagicWand2.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
